import { render, staticRenderFns } from "./mybankVostroNotifyList.vue?vue&type=template&id=1dae556e"
import script from "./mybankVostroNotifyList.vue?vue&type=script&lang=js"
export * from "./mybankVostroNotifyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports